/*
  Quick JS by Jason @ freakdesign.
  Corrigido para detectar corretamente a variante do produto
*/

(function () {
    "use strict";

    var debug = false;
    var cartCookie;

    function log(text) {
        console.log(text);
    }

    // Função melhorada para detectar a variante atual
    function getCurrentVariantId() {
        var variantId = null;
        var currentUrl = window.location.href;
        var urlMatch = currentUrl.match(/\/products\/([^\/\?]+)/);

        // Método 0: atributo escrito pelo próprio Liquid no widget de frete deste produto
        // (snippets/shipping.liquid, data-variant-id). É a fonte mais confiável porque não
        // depende de nenhum script terceiro ter carregado a tempo — o servidor já manda o
        // valor certo, escopado só a este widget.
        if (productSection && productSection[0] && productSection[0].dataset.variantId) {
            var attrVariantId = parseInt(productSection[0].dataset.variantId);
            if (attrVariantId) {
                return attrVariantId;
            }
        }

        // Método 1: window.meta.product, validado pelo handle da URL (confiável e sempre
        // se refere ao produto desta página, diferente das buscas abaixo que podem pegar
        // o formulário de outro produto exibido em qualquer lugar da página, ex: "Populares"
        // na busca do cabeçalho, recomendados, recentemente vistos etc.)
        if (urlMatch && window.meta && window.meta.product) {
            if (window.meta.product.handle === urlMatch[1] && window.meta.product.variants) {
                var availableVariant = window.meta.product.variants.find(v => v.available);
                if (availableVariant) {
                    variantId = parseInt(availableVariant.id);
                    return variantId;
                }
            }
        }

        // Método 2: objeto global product, também validado pelo handle
        if (typeof product !== 'undefined' && product.variants) {
            if (urlMatch && product.handle === urlMatch[1]) {
                var availableVariant = product.variants.find(v => v.available);
                if (availableVariant) {
                    variantId = parseInt(availableVariant.id);
                    return variantId;
                }
            }
        }

        // Método 3: dados estruturados JSON-LD, casando pelo SKU
        var jsonLdScript = document.querySelector('script[type="application/ld+json"]');
        if (jsonLdScript) {
            try {
                var jsonData = JSON.parse(jsonLdScript.textContent);
                if (jsonData['@type'] === 'Product' && jsonData.offers) {
                    var offer = Array.isArray(jsonData.offers) ? jsonData.offers[0] : jsonData.offers;
                    if (offer.sku) {
                        var variants = (window.meta && window.meta.product && window.meta.product.variants) ||
                                     (typeof product !== 'undefined' && product.variants) || [];
                        var matchingVariant = variants.find(v => v.sku === offer.sku);
                        if (matchingVariant) {
                            variantId = parseInt(matchingVariant.id);
                            return variantId;
                        }
                    }
                }
            } catch (e) {
            }
        }

        // A partir daqui os métodos não confirmam que o elemento pertence ao produto desta
        // página — só usar como último recurso, se nada acima funcionou.

        // Método 4: select/input do formulário principal do produto, escopado ao form que
        // contém o botão de comprar deste widget (não a página inteira)
        var productForm = productSection[0].closest('form') ||
            document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
            var variantInput = productForm.querySelector('input[name="id"], select[name="id"]');
            if (variantInput && variantInput.value) {
                variantId = parseInt(variantInput.value);
                return variantId;
            }
        }

        // Método 5: qualquer input/select[name="id"] na página (menos confiável — pode
        // pertencer a outro produto exibido em recomendações, busca, etc.)
        var productSelect = document.getElementById('ProductSelect-product-template');
        if (!productSelect) { productSelect = document.querySelector('select[name="id"]'); }
        if (!productSelect) { productSelect = document.querySelector('input[name="id"]'); }
        if (!productSelect) { productSelect = document.querySelector('[name="id"]'); }

        if (productSelect && productSelect.value && productSelect.value !== "") {
            variantId = parseInt(productSelect.value);
            return variantId;
        }

        return null;
    }

    var productSection = document.getElementsByClassName('frete-produto');
    if (!productSection.length) { log('Could not find the element'); return }

    var shippingMessage = document.createElement('p');
    var shippingCountry = document.createElement('select');
    var shippingProvince = document.createElement('select');
    var shippingZip = document.createElement('input');
    var freteLista = document.createElement('div');

    shippingMessage.classList.add('erros-fretes');
    shippingMessage.setAttribute("style", "display:none");

    freteLista.classList.add('listas-de-fretes');
    freteLista.setAttribute("style", "display:none");

    var initFields = function () {
        shippingCountry.id = "pais-simulator";
        var countries = ['Brazil'];
        for (var i = 0; i < countries.length; i++) {
            shippingCountry.add(new Option(countries[i], countries[i], i === 0));
        };
        shippingCountry.name = 'shipping_address[country]';

        shippingProvince.id = "estados-simulator";
        var provinces = ['Acre', 'Alagoas', 'Amapa', 'Amazonas', 'Bahia', 'Ceara', 'Distrito Federal', 'Espirito Santo', 'Goias', 'Maranhao', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Para', 'Paraiba', 'Parana', 'Pernambuco', 'Piaui', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondonia', 'Roraima', 'Santa Catarina', 'Sao Paulo', 'Sergipe', 'Tocantins'];
        for (var i = 0; i < provinces.length; i++) {
            shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
        };
        shippingProvince.name = 'shipping_address[province]';

        shippingZip.type = 'text';
        shippingZip.name = 'shipping_address[zip]';
        shippingZip.className = 'Form__Input cep-calculo-frete form-control';
        shippingZip.placeholder = '12.345-000';
        $(shippingZip).mask("00.000-000")

        var shippingCalcWrapper = document.createElement('div');
        shippingCalcWrapper.className = 'shipping-calc-wrapper';

        var formularioFrete = document.createElement('div');
        formularioFrete.className = 'formulario-frete';

        var shippingCalcTitle = document.createElement('p');
        shippingCalcTitle.innerText = 'Simule seu frete';

        var shippingCalcButton = document.createElement('a');
        shippingCalcButton.innerText = 'Calcular';
        shippingCalcButton.className = 'btn btn-underline button--secondary button';
        shippingCalcButton.onclick = function () {
            var cepLimpo = shippingZip.value.replace(/\D/g, '');

            shippingMessage.innerHTML = '';
            shippingMessage.setAttribute("style", "display:none");
            
            $.getJSON("https://viacep.com.br/ws/" + cepLimpo + "/json/?callback=?", function (dados) {
                if (!("erro" in dados)) {
                    switch (dados.uf) {
                        case 'AC': dados.uf = 'Acre'; break;
                        case 'AL': dados.uf = 'Alagoas'; break;
                        case 'AP': dados.uf = 'Amapa'; break;
                        case 'AM': dados.uf = 'Amazonas'; break;
                        case 'BA': dados.uf = 'Bahia'; break;
                        case 'CE': dados.uf = 'Ceara'; break;
                        case 'DF': dados.uf = 'Distrito Federal'; break;
                        case 'ES': dados.uf = 'Espirito Santo'; break;
                        case 'GO': dados.uf = 'Goias'; break;
                        case 'MA': dados.uf = 'Maranhao'; break;
                        case 'MT': dados.uf = 'Mato Grosso'; break;
                        case 'MS': dados.uf = 'Mato Grosso do Sul'; break;
                        case 'MG': dados.uf = 'Minas Gerais'; break;
                        case 'PA': dados.uf = 'Para'; break;
                        case 'PB': dados.uf = 'Paraiba'; break;
                        case 'PR': dados.uf = 'Parana'; break;
                        case 'PE': dados.uf = 'Pernambuco'; break;
                        case 'PI': dados.uf = 'Piaui'; break;
                        case 'RJ': dados.uf = 'Rio de Janeiro'; break;
                        case 'RN': dados.uf = 'Rio Grande do Norte'; break;
                        case 'RS': dados.uf = 'Rio Grande do Sul'; break;
                        case 'RO': dados.uf = 'Rondonia'; break;
                        case 'RR': dados.uf = 'Roraima'; break;
                        case 'SC': dados.uf = 'Santa Catarina'; break;
                        case 'SP': dados.uf = 'Sao Paulo'; break;
                        case 'SE': dados.uf = 'Sergipe'; break;
                        case 'TO': dados.uf = 'Tocantins'; break;
                    };

                    shippingProvince.value = dados.uf;

                    // Salvar cookie original
                    cartCookie = getCookie('cart');
                    
                    // Limpar completamente qualquer cache/session
                    if (typeof Storage !== "undefined") {
                        // Limpar localStorage relacionado ao carrinho
                        for (var key in localStorage) {
                            if (key.includes('cart') || key.includes('Cart')) {
                                localStorage.removeItem(key);
                            }
                        }
                        // Limpar sessionStorage relacionado ao carrinho  
                        for (var key in sessionStorage) {
                            if (key.includes('cart') || key.includes('Cart')) {
                                sessionStorage.removeItem(key);
                            }
                        }
                    }
                    
                    // Criar um novo cookie único para este cálculo
                    var uniqueCookieValue = "shipping-calc-" + Date.now() + "-" + Math.random().toString(36).substring(2, 15);
                    
                    // Definir novo cookie
                    updateCartCookie(uniqueCookieValue);
                    log('Using unique cookie:', getCookie('cart'));

                    // Usar a função melhorada para detectar a variante
                    var selectedVariant = getCurrentVariantId();
                    
                    if (selectedVariant) {
                        console.log('Calculando frete para variante:', selectedVariant);
                        checkProductPriceAndCalculate(selectedVariant);
                    } else {
                        console.log("Nenhuma variante válida encontrada");
                        shippingMessage.innerHTML = 'Não foi possível detectar o produto. Atualize a página e tente novamente.';
                        shippingMessage.setAttribute("style", "display:flex");
                        resetCartCookie();
                        return false;
                    }

                    return false;
                }
            }).fail(function () {
                $('.listas-de-fretes').html("");
                shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
                shippingMessage.setAttribute("style", "display:flex");
            });
        };

        // Continua com o resto da função initFields...
        var labelNames = ['País', 'Estado', 'CEP'];
        var labels = [];
        for (var i = 0; i < labelNames.length; i++) {
            var label = document.createElement('label');
            label.innerText = labelNames[i];
            labels.push(label);
        };

        shippingCalcWrapper.appendChild(formularioFrete);
        formularioFrete.appendChild(shippingCountry);
        formularioFrete.appendChild(shippingProvince);
        formularioFrete.appendChild(shippingZip);
        formularioFrete.appendChild(shippingCalcButton);
        shippingCalcWrapper.appendChild(shippingMessage);
        shippingCalcWrapper.appendChild(freteLista);

        productSection[0].appendChild(shippingCalcWrapper);
    };

    // Resto das funções permanecem iguais...
    var checkProductPriceAndCalculate = function(variantId) {
        var productPrice = null;

        // Fonte confiável: dados da variante injetados pelo próprio Shopify na página do produto.
        // (Antes usava document.querySelector('.price, .product-price, [data-price], .money'),
        // que pegava o primeiro elemento com essas classes em TODA a página — incluindo cards de
        // outros produtos na busca preditiva do cabeçalho — e não o preço do produto atual.)
        if (window.meta && window.meta.product && window.meta.product.variants) {
            var metaVariant = window.meta.product.variants.find(v => v.id == variantId);
            if (metaVariant) {
                productPrice = metaVariant.price / 100;
            }
        }

        if (productPrice === null && typeof product !== 'undefined' && product.variants) {
            var variant = product.variants.find(v => v.id == variantId);
            if (variant) {
                productPrice = variant.price / 100;
            }
        }

        console.log('Product price detected:', productPrice);

        if (productPrice !== null && productPrice >= 199) {
            // Este caminho nunca chama getRates(), que é onde o cookie do carrinho
            // descartável normalmente é trocado de volta pro carrinho real do cliente
            // (ver updateCartCookie/resetCartCookie mais acima). Sem isso aqui, o cookie
            // ficava preso no carrinho descartável toda vez que a calculadora era usada
            // num produto de R$199+, fazendo o carrinho real do cliente sumir de vista.
            resetCartCookie();
            $('.listas-de-fretes').html("");
            $('.listas-de-fretes').show();
            $('<div class="frete-item"> <div> <p class="m-0 nome-frete"><b>Frete Grátis</b> <span class="estimativa-de-entrega">(Compras acima de R$ 199)</span></p> </div><div class="frete-valor">Valor: <b>Grátis</b></div> </div>').appendTo('.listas-de-fretes');
        } else {
            getRates(variantId);
        }
    };

    var log = function (a) {
        if (!debug) { return }
        console.log(a);
    };

    var getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length == 2) return parts.pop().split(";").shift();
    };

    /* update the cart cookie value */
    var updateCartCookie = function (a) {
        log('changing cart cookie value to: ' + a);
        var date = new Date();
        date.setTime(date.getTime() + (14 * 86400000));
        var expires = '; expires=' + date.toGMTString();
        document.cookie = 'cart=' + a + expires + '; path=/';
        
        // Forçar limpeza do cache do carrinho
        if (typeof window.CartJS !== 'undefined' && window.CartJS.clear) {
            window.CartJS.clear();
        }
        
        // Limpar cache do Shopify se existir
        if (typeof theme !== 'undefined' && theme.cart && theme.cart.clear) {
            theme.cart.clear();
        }
    };

    var resetCartCookie = function () {
        if (cartCookie && cartCookie.length > 0) {
            updateCartCookie(cartCookie);
        }
        log('Cookie restored to:', getCookie('cart'));
    };

    var getRates = function (variantId) {
        $('.listas-de-fretes').html("");
        $('.listas-de-fretes').show();

        if (typeof variantId === 'undefined') { return }

        var productQuantity = document.getElementById('Quantity');
        var quantity = productQuantity ? parseInt(productQuantity.value) : 1;
        var addData = {
            'id': variantId,
            'quantity': quantity
        };

        function isDateBeforeToday(date) {
            return new Date(date.toDateString()) < new Date(new Date().toDateString());
        }

        function excludeDate(name) {
            var response = (name != 'Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis' && name != 'Entrega Rápida - pedidos chegam em até 48hrs úteis');
            return response;
        }

        // Mesma regra de frete grátis por região usada na barra de progresso do carrinho
        // (settings.calculator_free_shipping_region_1/2_price, lidos do próprio widget via
        // data-attribute — nada fixo aqui, se o valor mudar no editor do tema já reflete).
        // A API crua de /cart/shipping_rates.json pode devolver preço "0.00" para uma
        // transportadora mesmo quando o carrinho não atinge esse mínimo (é o custo negociado
        // com a transportadora, não o valor repassado ao cliente) — o checkout aplica esse
        // filtro, essa simulação precisa aplicar também.
        var SUDESTE_PROVINCES = ['Sao Paulo', 'Rio de Janeiro', 'Minas Gerais', 'Espirito Santo'];
        var region1Price = parseFloat(productSection[0].dataset.freeshipRegion1Price) || 99;
        var region2Price = parseFloat(productSection[0].dataset.freeshipRegion2Price) || 199;
        function getFreeShippingThreshold(province) {
            return SUDESTE_PROVINCES.indexOf(province) !== -1 ? region1Price : region2Price;
        }

        // Não precisa de /cart/clear.js aqui: o cookie de carrinho já foi trocado por um
        // valor único antes desta função ser chamada (ver updateCartCookie), então o
        // carrinho associado a esse token nasce vazio — limpar um carrinho que já está
        // vazio só custa uma chamada de rede a mais (~0,6s medidos) sem efeito nenhum.
        fetch('/cart/add.js?_easygift_internal=true', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            console.log('Product added to clean cart:', json);
            
            // Verificar se o produto adicionado é o correto
            if (json.variant_id && json.variant_id != variantId) {
                console.error('ERRO: Produto errado adicionado!');
                console.error('Esperado:', variantId, 'Recebido:', json.variant_id);
                resetCartCookie();
                shippingMessage.innerHTML = 'Erro ao calcular frete. Produto incorreto detectado.';
                shippingMessage.setAttribute("style", "display:flex");
                return;
            }

            // line_price já vem do /cart/add.js: preço unitário x quantidade, em centavos
            var cartSubtotal = (json.line_price || 0) / 100;
            var freeShippingThreshold = getFreeShippingThreshold(shippingProvince.value);

            $.ajax({
                type: "GET",
                url: '/cart/shipping_rates.json?_easygift_internal=true',
                data: {
                    'shipping_address[country]': shippingCountry.value,
                    'shipping_address[province]': shippingProvince.value,
                    'shipping_address[zip]': shippingZip.value
                },
                beforeSend: function () {
                    $('.listas-de-fretes').html("<img id='loading-icon-frete' src='https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif?v=1621716543' width='30px' style='width:30px; height: 30px; margin:0 auto'>");
                },
                success: function (d) {
                    if (d.shipping_rates && d.shipping_rates.length) {
                        var renderedCount = 0;
                        for (var i = 0; i < d.shipping_rates.length; i++) {
                            var deliveryDate = d.shipping_rates[i].delivery_date;
                            var entrega = new Date(d.shipping_rates[i].delivery_date);
                            var checkBeforeday = isDateBeforeToday(entrega);
                            var excludeDateCheck = excludeDate(d.shipping_rates[i].name);
                            let dataFormatada = ((entrega.getDate())) + "/" + ((entrega.getMonth() + 1)) + "/" + entrega.getFullYear();

                            var valorFrete = d.shipping_rates[i].price;
                            var isZeroRate = (valorFrete == "0.00" || valorFrete == null);

                            // A transportadora pode devolver custo "0.00" (o que a loja paga a
                            // ela) mesmo quando o carrinho não atinge o mínimo de frete grátis
                            // da região — isso não é o valor que o cliente pagaria no checkout,
                            // então não mostra essa opção como grátis (nem mostra ela) nesse caso.
                            if (isZeroRate && cartSubtotal < freeShippingThreshold) {
                                continue;
                            }

                            if (isZeroRate) { valorFrete = "Grátis" } else { valorFrete = Shopify.formatMoney(valorFrete, 'R$ {{amount_with_comma_separator}}') };

                            if (deliveryDate == null && excludeDateCheck || checkBeforeday && excludeDateCheck) {
                                entrega = "Estimativa de entrega indisponível"
                            } else if (!excludeDateCheck) {
                                if (d.shipping_rates[i].name == "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis") {
                                    entrega = ""
                                } else {
                                    entrega = ""
                                }
                            } else {
                                var diasSemana = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
                                var diaSemana = diasSemana[entrega.getDay()];
                                var ddChega = ('0' + entrega.getDate()).slice(-2);
                                var mmChega = ('0' + (entrega.getMonth() + 1)).slice(-2);
                                entrega = "Chegará " + diaSemana + " - " + ddChega + "/" + mmChega;
                            }

                            $('<div class="frete-item"> <div> <p class="m-0 nome-frete"><b>' + d.shipping_rates[i].name + '</b> <span class="estimativa-de-entrega">' + entrega + '</span></p> </div><div class="frete-valor">Valor: <b> ' + valorFrete + '</b></div> </div>').appendTo('.listas-de-fretes');
                            renderedCount++;
                        };

                        if (renderedCount === 0) {
                            shippingMessage.innerHTML = 'Nenhuma opção de frete disponível para esse CEP.';
                            shippingMessage.setAttribute("style", "display:flex");
                        }

                        $('#loading-icon-frete').remove();
                        console.log("Removido");
                    }
                    resetCartCookie();
                },
                error: function () {
                    resetCartCookie();
                    $('.listas-de-fretes').html("");
                    shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
                    shippingMessage.setAttribute("style", "display:flex");
                },
                dataType: 'json'
            }).fail(function () {
                alert("fail");
            })

        }).catch(function (err) {
            console.error(err);
            resetCartCookie()
        });
    };

    initFields();
})();